import { httpRequest } from "../../http";

export class CommandRunFile {
  async run(fileId: number): Promise<{ job_ids: number[] }> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/files/${fileId}/run/`;
    return httpRequest<{ job_ids: number[] }>(url, { method: "POST" });
  }
}
